import { render } from "./MailCommentsList.vue?vue&type=template&id=2da796b8"
import script from "./MailCommentsList.vue?vue&type=script&lang=js"
export * from "./MailCommentsList.vue?vue&type=script&lang=js"

import "./MailCommentsList.vue?vue&type=style&index=0&id=2da796b8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__